import React from 'react';
import { Col, Row } from "antd";
import { InputToolItem } from './InputToolItem';

const MultipleRowDefaultPropertiesPanel = ({
    rowSeatSpacing,
    rowSeatSpacingHandler,
    rowSpacing,
    rowSpacingHandler,
    rowSeatSize,
    rowSeatSizeHandler,
}) => {
    const items = [
        {
            label: "Espacio entre filas",
            value: rowSpacing,
            onChange: rowSpacingHandler,
        },
        {
            label: "Espacio entre asientos",
            value: rowSeatSpacing,
            onChange: rowSeatSpacingHandler,
        },
        {
            label: "Tamaño de asiento",
            value: rowSeatSize,
            onChange: rowSeatSizeHandler,
            min: 10,
        },
    ];

    return (
        <Row>
            <Col span={24} className="mb-2">
                <h3>Configuración de filas múltiples</h3>
            </Col>

            {items.map((item, index) => (
                <InputToolItem key={index} {...item} />
            ))}
        </Row>
    );
};

export { MultipleRowDefaultPropertiesPanel };